import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

const CommonFilter = ({
  show,
  onClose,
  data,
  filterFields,
  onFilter,
  dateKey,
}) => {
  const [filters, setFilters] = useState({});
  const [dropdownOptions, setDropdownOptions] = useState({});

  useEffect(() => {
    const newOptions = {};
    filterFields.forEach(({ key, type }) => {
      if (type !== "dateRange") {
        const uniqueValues = Array.from(
          new Set(data.map((item) => item[key]))
        ).filter(Boolean);

        newOptions[key] = uniqueValues;
      }
    });
    setDropdownOptions(newOptions);
  }, [data, filterFields]);

  const handleChange = (key, value) => {
    setFilters((prev) => {
      const newFilters = { ...prev };
      if (
        (typeof value === "string" && value === "") ||
        (typeof value === "object" && !value?.from && !value?.to)
      ) {
        delete newFilters[key];
      } else {
        newFilters[key] = value;
      }
      return newFilters;
    });
  };

  const clearAll = () => {
    setFilters({});
    onFilter(data);
    onClose();
  };

  const applyFilters = () => {
    const filteredData = data.filter((item) => {
      return filterFields.every(({ key, type }) => {
        if (type === "dateRange") {
          const itemDate = dayjs(item[dateKey], "DD MMM YYYY HH:mm:ss");
          const from = filters[key]?.from ? dayjs(filters[key].from) : null;
          const to = filters[key]?.to ? dayjs(filters[key].to) : null;
          if (from && itemDate.isBefore(from, "day")) return false;
          if (to && itemDate.isAfter(to, "day")) return false;
          return true;
        }

        if (!filters[key]) return true;

        // 🔑 Fix: compare as strings
        return String(item[key]) === String(filters[key]);
      });
    });
    onFilter(filteredData);
  };
  if (!show) return null;
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      onClick={handleOverlayClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "transparent",
        zIndex: 1400,
      }}
    >
      <div
        style={{
          position: "fixed",
          top: "80px",
          right: "40px",
          width: "320px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "16px",
          padding: "0",
          zIndex: 1500,
          boxShadow: "0px 12px 24px rgba(0,0,0,0.15)",
          fontFamily: "Segoe UI, Roboto, sans-serif",
          animation: "slideIn 0.3s ease-out",
        }}
      >
        <div
          style={{
            padding: "20px 24px",
            borderBottom: "1px solid #f0f0f0",
            background: "linear-gradient(135deg,#4151e0)",
            borderRadius: "16px 16px 0 0",
            position: "relative",
            color: "#fff",
            fontSize: "18px",
            fontWeight: "600",
          }}
        >
          🔍 Filter Inventory
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              background: "rgba(255,255,255,0.2)",
              border: "none",
              color: "#fff",
              fontSize: "18px",
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: "24px" }}>
          {filterFields.map(({ key, label, type }) => {
            if (type === "dateRange") {
              return (
                <div key={key} style={{ marginBottom: "20px" }}>
                  <label
                    style={{
                      fontWeight: "600",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  >
                    {label}
                  </label>
                  <div style={{ display: "flex", gap: "12px" }}>
                    <input
                      type="date"
                      value={filters[key]?.from || ""}
                      onChange={(e) =>
                        handleChange(key, {
                          ...filters[key],
                          from: e.target.value || undefined,
                        })
                      }
                      style={{
                        flex: 1,
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <input
                      type="date"
                      value={filters[key]?.to || ""}
                      onChange={(e) =>
                        handleChange(key, {
                          ...filters[key],
                          to: e.target.value || undefined,
                        })
                      }
                      style={{
                        flex: 1,
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </div>
                </div>
              );
            } else {
              return (
                <div key={key} style={{ marginBottom: "20px" }}>
                  <label
                    style={{
                      fontWeight: "600",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  >
                    {label}
                  </label>
                  <select
                    value={filters[key] || ""}
                    onChange={(e) => handleChange(key, e.target.value)}
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      fontSize: "14px",
                    }}
                  >
                    <option value="">Select {label}...</option>
                    {dropdownOptions[key]?.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              );
            }
          })}

          <div style={{ display: "flex", gap: "12px" }}>
            <button
              onClick={clearAll}
              style={{
                flex: 1,
                backgroundColor: "#f5f5f5",
                border: "2px solid #e0e0e0",
                color: "#666",
                padding: "12px 16px",
                borderRadius: "10px",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              Reset
            </button>
            <button
              onClick={applyFilters}
              style={{
                flex: 1,
                background: "linear-gradient(135deg,#4151e0)",
                color: "#fff",
                border: "none",
                padding: "12px 16px",
                borderRadius: "10px",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              Apply
            </button>
          </div>
        </div>

        <style>
          {`
          @keyframes slideIn {
            from { opacity: 0; transform: translateX(20px) scale(0.95); }
            to { opacity: 1; transform: translateX(0) scale(1); }
          }
        `}
        </style>
      </div>
    </div>
  );
};

export default CommonFilter;
